/**
 * Armazon de todas las vistas publicas: cabecera, contenido y pie.
 *
 * El arbol del documento es el que espera un lector de pantalla y un robot:
 * `header` > `main` > `footer`, con el enlace de salto al contenido como primer
 * elemento tabulable de la pagina.
 *
 * La navegacion del catalogo se pide una sola vez aca y baja a la cabecera y al
 * pie: son la misma informacion y no tiene sentido pedirla dos veces por vista.
 *
 * `ProveedorDespacho` envuelve la tienda por el mismo motivo: el monto de
 * despacho gratis se anuncia en cinco lugares distintos y lo administra el
 * backoffice (ADM-10), asi que se pide una vez y baja a todos.
 */
import type { ReactNode } from 'react';
import { Outlet } from 'react-router-dom';

import { ProveedorDespacho } from '../../contexto/despacho';
import { usePeticion } from '../../hooks/use-peticion';
import { obtenerNavegacion } from '../../servicios/catalogo.servicio';
import { BotonWhatsappFlotante } from './BotonWhatsappFlotante';
import { Cabecera } from './Cabecera';
import { PieDePagina } from './PieDePagina';

const RESUMEN_VACIO = { productos: 0, lineas: 0, categorias: 0, marcas: 0 };

export function DisenoTienda({ children }: { children?: ReactNode }) {
  const navegacion = usePeticion((senal) => obtenerNavegacion(senal), []);
  const lineas = navegacion.datos?.lineas ?? [];
  const resumen = navegacion.datos?.resumen ?? RESUMEN_VACIO;

  return (
    <ProveedorDespacho>
      <a className="saltar-al-contenido" href="#contenido">
        Saltar al contenido
      </a>

      <Cabecera lineas={lineas} />

      <main id="contenido" tabIndex={-1}>
        {children ?? <Outlet />}
      </main>

      <PieDePagina resumen={resumen} />
      <BotonWhatsappFlotante />
    </ProveedorDespacho>
  );
}
